import { createElement as $$createElement, setStyle as $$setStyle, setDataset as $$setDataset, setEvent as $$setEvent, delegateEvent as $$delegateEvent, setHTMLProp as $$setHTMLProp, setHTMLAttr as $$setHTMLAttr, setHTMLProps as $$setHTMLProps, setHTMLAttrs as $$setHTMLAttrs, createTextNode as $$createTextNode, updateText as $$updateText, insertNode as $$insertNode, ForNode as $$ForNode, CondNode as $$CondNode, ExpNode as $$ExpNode, EnvNode as $$EnvNode, TryNode as $$TryNode, SnippetNode as $$SnippetNode, PropView as $$PropView, render as $$render } from "@dlightjs/dlight";
import { Pretty, Typed, View } from "@dlightjs/dlight";
class Spacer extends View {
  isSpacer = true;
  Body() {
    let $node0;
    $node0 = $$createElement("div");
    $$setStyle($node0, {
      flexGrow: 1
    });
    return [$node0];
  }
}
export default ((Spacer as Pretty) as Typed);